import {createRoot} from "react-dom/client";
import {DomPortal} from "../../../../modules/abstract/portal/DomPortal";
import {notify} from "../../../../../utils/Notify";
import {NotificationType} from "../../../popup/NotificationV5";
import type {AppState} from "../../../../../data/state/AppState";
import {PopupBackdropV5} from "../../../popup/PopupBackdropV5";
import {Functions} from "../../../../../utils/function/Functions";
import {PartialSucesspopup} from "../../../../modules/catalog/create/PartialSucessPopup";
import {PartialSucesspopupV5} from "./PartialSucessPopupV5";

export interface MissingField {
	fieldKey: string;
	missingValues: string[];
}

const detectDeletedOptions = (
	requestFieldData: Record<string, string | string[]>,
	responseFieldData: Record<string, string | string[]>,
	appState: AppState,
): MissingField[] => {
	const missing: MissingField[] = [];

	for (const key in requestFieldData) {
		if (key === "model") {
			continue;
		}

		const field = appState.actions.getFieldByRefId(key);
		if (!field) {
			continue;
		}

		const reqVal = requestFieldData[key];
		const resVal = responseFieldData?.[key];

		if (Array.isArray(reqVal)) {
			const resArr = Array.isArray(resVal) ? resVal : [];
			const missingVals = reqVal.filter((val) => !resArr.includes(val));
			if (missingVals.length > 0) {
				missing.push({fieldKey: key, missingValues: missingVals});
			}
		} else {
			if (reqVal && reqVal !== resVal) {
				missing.push({fieldKey: key, missingValues: [reqVal]});
			}
		}
	}

	return missing;
};

function showMissingFieldsPopup(missingFields: MissingField[], appState: any) {
	const containerId = "partial-details-portal";
	let container = document.getElementById(containerId);

	if (!container) {
		container = document.createElement("div");
		container.id = containerId;
		document.body.appendChild(container);
	}

	const root = createRoot(container);
	const version = appState.currentUIVersion;
	const PopupComponent = version === "5.0" ? PartialSucesspopupV5 : PartialSucesspopup;

	root.render(
		<DomPortal destination={appState.app.modalContainer}>
			<PopupBackdropV5 onClick={Functions.stopPropagation}>
				<PopupComponent
					missingFields={missingFields}
					onClose={() => {
						root.unmount();
						container?.remove();
					}}
				/>
			</PopupBackdropV5>
		</DomPortal>,
	);
}

export function compareAndNotify(
	requestData: Record<string, string | string[]>,
	responseData: Record<string, string | string[]>,
	appState: AppState,
) {
	const missingFields = detectDeletedOptions(requestData, responseData, appState);

	if (missingFields.length > 0) {
		notify(appState.app.notificationContainer, {
			type: NotificationType.Warning,
			title: `The catalog item was partially duplicated.`,
			description: `Certain values were removed as they are no longer valid.`,
			lifeTime: 10000,
			buttonLabel: "Show Details",
			onActionButtonClick: () => {
				showMissingFieldsPopup(missingFields, appState);
			},
		});
	}
}
